/*
 * @Author       : 星海
 * @Date         : 2023-05-08 09:43:27
 * @LastEditors  : 星海
 * @LastEditTime : 2023-05-08 16:51:28
 * @Description  : -
 */
import {
  getUserInfo,
  modifyUserInfo,
  getCaptcha,
  getMobileCode,
  prevCheck,
  modifyMobile,
  unbindRegister,
} from '../services/index';

export default {
  namespace: 'basicInfoMaintain',
  state: {
  },
  effects: {
    * getUserInfo ({ payload }, { call }) {
      return yield call(getUserInfo, payload);
    },
    * modifyUserInfo ({ payload }, { call }) {
      return yield call(modifyUserInfo, payload);
    },
    * getCaptcha ({ payload }, { call }) {
      return yield call(getCaptcha, payload);
    },
    * getMobileCode ({ payload }, { call }) {
      return yield call(getMobileCode, payload);
    },
    * prevCheck ({ payload }, { call }) {
      return yield call(prevCheck, payload);
    },
    * modifyMobile ({ payload }, { call }) {
      return yield call(modifyMobile, payload);
    },
    * unbindRegister ({ payload }, { call }) {
      return yield call(unbindRegister, payload);
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
